module.exports = __webpack_public_path__ + "img/Comercio.20c77f41.png";